export function KnowledgeBaseModulePlaceholder() {
  return (
    <section className="card">
      <h3 className="page-title" style={{ fontSize: "1.05rem" }}>
        Base de conhecimento
      </h3>
      <p className="section-description">Espaço reservado para artigos, guias e respostas rápidas.</p>
    </section>
  );
}
